module.exports = __webpack_public_path__ + "img/menu_ladies_tenteki.ffddaaf9.png";